import * as React from "react";

export interface TableRefresh {
    refreshCount: number;
    onHandleRefresh: () => void;
}

// Bump refreshCount to make a data table re-fetch its data.
export function useTableRefresh(): TableRefresh {
    const [refreshCount, setRefreshCount] = React.useState(0);

    function onHandleRefresh() {
        setRefreshCount((previousRefreshCount) => previousRefreshCount + 1);
    }

    return { refreshCount, onHandleRefresh };
}
